export type SuggestionSortMode = "None" | "Popularity";
